import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import SitelogApi from '../api/siteLogApi';

const SITE_LOGS_KEY = 'siteLogs';

export const useSiteLogs = () => {
  return useQuery({
    queryKey: [SITE_LOGS_KEY],
    queryFn: async () => {
      const queryStr = toDataSourceRequestString({ skip: 0, take: 0 });
      const response = await SitelogApi.getSiteLogs(queryStr);
      const payload = response.data || {};
      return {
        data: payload.data || [],
        total: payload.total || 0,
      };
    },
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
  });
};

export const useInvalidateSiteLogs = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: [SITE_LOGS_KEY] });
};

// Optimistically remove rows by controlLogId from the cached data.
// Use after successful delete so the UI updates instantly.
export const useRemoveFromSiteLogsCache = () => {
  const queryClient = useQueryClient();
  return (ids) => {
    if (!Array.isArray(ids) || ids.length === 0) return;
    const idSet = new Set(ids);
    queryClient.setQueryData([SITE_LOGS_KEY], (old) => {
      if (!old) return old;
      const remaining = (old.data || []).filter((d) => !idSet.has(d.controlLogId));
      const removed = (old.data || []).length - remaining.length;
      return {
        ...old,
        data: remaining,
        total: Math.max(0, (old.total || 0) - removed),
      };
    });
  };
};
